<template>
    <tr>
        <td colspan="6">
            <table class="nm-table">
                <tbody>
                    <tr>
                        <td class="label"> Label </td>
                        <td class="value"> {{ metadata.neuronLabel }}</td>
                    </tr>
                    <tr v-if="(metadata.neuronPrefLabel !== '')">
                        <td class="label">Preferred Label</td>
                        <td class="value"> {{ metadata.neuronPrefLabel }}</td>
                    </tr>
                    <tr>
                        <td class="label">Phenotype(s)</td>
                        <td class="value">{{ metadata.phenotypes }}</td>
                    </tr>
                    <tr v-if="metadata.species !== ''">
                        <td class="label">Species</td>
                        <td class="value">{{ metadata.species }}</td>
                    </tr>
                    <tr v-if="metadata.forwardConnections">
                        <td class="label">Forward Connection(s)</td>
                        <td class="value">{{ metadata.forwardConnections }}</td>
                    </tr>
                    <tr v-if="metadata.reference !== ''">
                        <td class="label">Reference</td>
                        <td class="value" v-html="addHyperlinksToURIs(metadata.reference)"></td>
                    </tr>
                    <tr v-if="metadata.citations !== ''">
                        <td class="label">Citations</td>
                        <td class="value" v-html="addHyperlinksToCitationURIs(metadata.citations)"></td>
                    </tr>
                    <tr v-if="metadata.alert !== ''">
                        <td class="label">Alert Note</td>
                        <td class="value" v-html="addHyperlinksToURIs(metadata.alert)"></td>
                    </tr>
                </tbody>
            </table>
        </td>
    </tr>
</template>
<script>

export default {
    props: ['metadata'],
    methods: {
        addHyperlinksToURIs(text) {
            // Regular expression to match URIs ignoring punctuation charecters or any braces 
            // at the end of a url within the texts
            const uriRegex = /(https?:\/\/[^\s,:]+[^\s.)},;:])/g;

            // Replace URIs with hyperlinks
            const result = text.replace(uriRegex, '<a href="$&" target="_blank">$&</a>');

            return result;
        },
        addHyperlinksToCitationURIs(text) {
            // Split the comma-separated string into an array of URIs
            const urisArray = text.split(',');

            const hyperlinksArray = urisArray.map(uri => {
                const trimmedURI = uri.trim();  // Remove any extra spaces
                return `<a href="${trimmedURI}" target="_blank">${trimmedURI}</a>`;
            });

            // Join the array of hyperlinks back into a single string
            return hyperlinksArray.join(', ');
        }
    },
    is_uri(text) {
        const uriRegex = /(https?:\/\/[^\s,:]+[^\s.)},;:])/g;
        return text.match(uriRegex)
    },


}
</script>

<style scoped>
.nm-table {
    border-collapse: collapse;
    width: 100%;
    background-color: #EFF5FB;
}

.label {
    font-weight: bold;
    width: 30px;
    background-color: #EFF5FB;
    padding: 8px;
    text-align: left;
}

.value {
    width: 90%;
    padding: 8px;
    text-align: left;
}
</style>